<template>
    <v-row  id="facility__features">
        <v-col cols="12">
            <h2 class="mt-4">
                Features
            </h2>
        </v-col>

        <v-col cols="12">
            <h3>Storage Solutions</h3>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="feature in features"
          :key="feature.id"
          v-if="loaded && feature.category === 'Storage Solutions'"
        >
            <v-switch
                :label="feature.text"
                v-model="currentFacility.features[feature.id]"
            />
        </v-col>

        <v-col cols="12">
            <hr>
        </v-col>

        <v-col cols="12">
            <h3>Amenities</h3>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="feature in features"
          :key="feature.id"
          v-if="loaded && feature.category === 'Amenities'"
        >
            <v-switch
                :label="feature.text"
                v-model="currentFacility.features[feature.id]"
            />
        </v-col>

        <v-col cols="12">
            <hr>
        </v-col>

        <v-col cols="12">
            <h3>Safety and Security</h3>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="feature in features"
          :key="feature.id"
          v-if="loaded && feature.category === 'Safety and Security'"
        >
            <v-switch
                :label="feature.text"
                v-model="currentFacility.features[feature.id]"
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
  data() {
    return {
      loaded: false
    };
  },

  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },

      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    },
    features() {
      return this.$store.state.facilityFeature.features;
    }
  },

  created() {
    this.$store.dispatch("getAllFeaturesForFacility", { perPage: 999 })
      .then(() => {
        this.loaded = true;
      });
  }
};
</script>
